<template>
  <div class="truncate">
    <SFLink
      v-for="({ value: name, to }, index) in formattedProductCategories"
      :key="`breadcrumb-${name}`"
      :data-testid="`category-breadcrumb-${index}`"
      :to="to"
      raw
      :class="{
        'pl-0': index === 0,
      }"
    >
      <span
        class="text-md leading-none text-gray-500 transition-all hover:text-anthracite-800"
        :title="name"
      >
        {{ name }}
      </span>
      <span
        v-if="showDividerTag(index, productCategories.length)"
        class="mx-2 hidden text-md leading-none text-gray-500 md:inline"
      >
        |
      </span>
      <span
        v-if="showDividerTag(index, productCategories.length)"
        class="mx-2 inline text-md leading-none text-gray-500 md:hidden"
      >
        &gt;
      </span>
    </SFLink>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ProductCategory } from '@scayle/storefront-nuxt'
import { useCurrentShop } from '@scayle/storefront-nuxt/composables'
import { SFLink } from '#storefront-ui/components'
import { useBreadcrumbs, useGenderMenuItems } from '~/composables'
import { showDividerTag } from '#storefront-ui'
import { formatBreadcrumbs } from '~/utils/breadcrumbs'

const { productCategories } = defineProps<{
  productCategories: ProductCategory[]
}>()

const { getBreadcrumbsFromProductCategories } = useBreadcrumbs()
const { isValidGender } = useGenderMenuItems()
const currentShop = useCurrentShop()
const formattedProductCategories = computed(() =>
  formatBreadcrumbs(
    getBreadcrumbsFromProductCategories(productCategories),
    currentShop.value.path || 'en-eu',
    isValidGender,
  ),
)
</script>
